<template>
  <div v-show="showTit === '操盘必读'">
    <p
      class="nothing-tips"
      v-if="
        affairDataShow &&
        modleDataShow &&
        makeDataShow &&
        !eventData &&
        !targetData &&
        !makeData &&
        !shareBonusData &&
        !repoData &&
        !industryData &&
        !ratingData &&
        !overviewData
      "
    >
      暂无数据
    </p>
    <!-- 必读 -->
    <section class="main">
      <!-- 最新指标 -->
      <hgroup class="mainPage zyzb" v-if="targetData">
        <header>
          最新指标<span>{{ targetData.zyzb.BGLX }}</span
          ><small class="fr" v-if="targetData.zyzb.CUR"
            >币种：{{ targetData.zyzb.CUR }}</small
          >
        </header>
        <div class="m-block">
          <ul class="m-list fl">
            <li>
              <label>每股收益</label>
              <span>{{ targetData.zyzb.MGSY ? targetData.zyzb.MGSY : "--" }}</span>
            </li>
            <li>
              <label>每股现金流</label>
              <span>{{ targetData.zyzb.MGXJL ? targetData.zyzb.MGXJL : "--" }}</span>
            </li>
            <li>
              <label>净利润</label>
              <span>{{ targetData.zyzb.JLR ? targetData.zyzb.JLR : "--" }}</span>
            </li>
            <li>
              <label>总资本回报率</label>
              <span>{{
                targetData.zyzb.ZZCHBL ? targetData.zyzb.ZZCHBL + "%" : "--"
              }}</span>
            </li>
            <li>
              <label>资产负债率</label>
              <span>{{
                targetData.zyzb.ZCFZL ? targetData.zyzb.ZCFZL + "%" : "--"
              }}</span>
            </li>
          </ul>
          <ul class="m-list fr">
            <li>
              <label>每股净资产</label>
              <span>{{ targetData.zyzb.MGJZC ? targetData.zyzb.MGJZC : "--" }}</span>
            </li>
            <li>
              <label>营业收入</label>
              <span>{{ targetData.zyzb.YYZSR ? targetData.zyzb.YYZSR : "--" }}</span>
            </li>
            <li>
              <label>总股本</label>
              <span>{{ targetData.zyzb.ZGB ? targetData.zyzb.ZGB + "股" : "--" }}</span>
            </li>
            <li>
              <label>净资产收益率</label>
              <span>{{
                targetData.zyzb.JZCSYL ? targetData.zyzb.JZCSYL + "%" : "--"
              }}</span>
            </li>
            <li>
              <label class="small_lab">股东权益回报率</label>
              <span>{{
                targetData.zyzb.GDQYSYL ? targetData.zyzb.GDQYSYL + "%" : "--"
              }}</span>
            </li>
          </ul>
        </div>
      </hgroup>
      <!-- 大事提醒 -->
      <hgroup class="mainPage xxtx" v-if="eventData">
        <header>大事提醒<a href="JavaScript:;" @click="goLink">更多</a></header>
        <ul class="xxtx-timeLine">
          <li>
            <span class="time"
              >{{ eventData[0].REMINDERDATE_S.substr(5, 5)
              }}<small>{{ eventData[0].REMINDERDATE_S.substr(0, 4) }}</small></span
            >
            <h6>{{ eventData[0].REMINDERNAME }}</h6>
            <p>
              <strong>{{
                eventData[0].show
                  ? eventData[0].REMINDERMEMO
                  : eventData[0].REMINDERMEMO.substring(0, 34) + "..."
              }}</strong
              ><span class="timeLine-open" @click="showsjtx(0)">{{
                eventData[0].show ? "收起" : "展开"
              }}</span>
            </p>
          </li>
          <li>
            <span class="time"
              >{{ eventData[1].REMINDERDATE_S.substr(5, 5)
              }}<small>{{ eventData[1].REMINDERDATE_S.substr(0, 4) }}</small></span
            >
            <h6>{{ eventData[1].REMINDERNAME }}</h6>
            <p>
              <strong>{{
                eventData[1].show
                  ? eventData[1].REMINDERMEMO
                  : eventData[1].REMINDERMEMO.substring(0, 34) + "..."
              }}</strong
              ><span class="timeLine-open" @click="showsjtx(1)">{{
                eventData[1].show ? "收起" : "展开"
              }}</span>
            </p>
          </li>
        </ul>
      </hgroup>
      <!-- 公司概况 -->
      <hgroup class="mainPage gsjj bdgs" v-if="overviewData">
        <header>
          公司概况<a href="JavaScript:;" @click="$parent.showTit = '公司概况'">更多</a>
        </header>
        <div class="block-card card-quote" v-if="overviewData.zyld">
          {{ overviewData.zyld }}
        </div>
        <table class="table table-col2" width="100%">
          <tr v-if="overviewData.bkmc">
            <td>所属行业</td>
            <td @click="goFs(overviewData.bkdm)">
              <a href="JavaScript:;">{{ overviewData.bkmc }}</a>
              <span :class="bkFs | zygdColor" v-if="bkFs">（{{ bkFs | bkfsText }}）</span>
            </td>
          </tr>
          <tr v-if="overviewData.ssrq">
            <td>上市时间</td>
            <td>{{ overviewData.ssrq }}</td>
          </tr>
          <tr v-if="overviewData.fxjg">
            <td>发行价格</td>
            <td>{{ gains(overviewData.fxjg, "港元") }}</td>
          </tr>
          <tr v-if="overviewData.zyyw">
            <td>主营业务</td>
            <td>
              <strong class="split-line3">
                {{
                  zyywShow && overviewData.zyyw.length > 40
                    ? overviewData.zyyw.substr(0, 40) + "..."
                    : overviewData.zyyw
                }}
              </strong>
              <span
                class="timeLine-open"
                v-if="overviewData.zyyw.length > 40"
                @click="zyywShow = !zyywShow"
                >{{ zyywShow ? "展开" : "收起" }}</span
              >
            </td>
          </tr>
        </table>
      </hgroup>
      <!-- 主营构成 -->
      <hgroup class="mainPage zygc zygc-bd linkInside" v-if="makeData">
        <header>
          主营构成<span>{{ makeData ? makeData.time : null }}</span>
          <a :href="linkUrl">更多</a>
        </header>
        <div class="tab-sub-cont">
          <div class="canvas canvas-zlcc-all">
            <div class="fl canvas-circle">
              <div class="canvas-zygc-pie" id="zygcPie"></div>
            </div>
            <div class="canvas-info canvas-table-col3">
              <table class="table" width="100%">
                <tr>
                  <th>业务</th>
                  <th>营业收入</th>
                  <th>占比</th>
                </tr>
                <tr v-for="(item, index) in makeData.arr" :key="index">
                  <td>{{ item.pbacname }}</td>
                  <td>{{ item.fvalue }}</td>
                  <td>{{ item.fvalueRate }}%</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </hgroup>
      <!-- 股本股东 -->
      <hgroup class="mainPage gdhs bdgb" v-if="gbjgData">
        <header>
          股本股东<a href="JavaScript:;" @click="$parent.showTit = '股本股东'">更多</a>
        </header>
        <div class="gbgd-item">
          <div class="shadow-block gbgd-float-tip flex">
            <dl>
              <dt class="legend-org">总股本(股)</dt>
              <dd>{{ process(gbjgData.zgb) }}</dd>
            </dl>
            <dl>
              <dt>流通股(股)</dt>
              <dd>{{ process(gbjgData.ltg) }}</dd>
            </dl>
            <dl>
              <dt class="legend-red">H股股本(股)</dt>
              <dd>{{ process(gbjgData.hggb) }}</dd>
            </dl>
          </div>
          <div class="gbgd-progress-bar">
            <div class="gbgd-bar-tit fl">
              {{ gbjgData.hgzzgb }}%<small>H股占总股本</small>
            </div>
            <div class="gbgd-bar-block">
              <span :style="{ width: gbjgData.hgzzgb + '%' }"></span>
            </div>
          </div>
        </div>
        <div class="gbgd-item">
          <div class="table_l">第一大股东</div>
          <div class="table_r">
            <div v-for="(item, index) in dydgdData" :key="index">
              <span class="table_r_first">{{ item.gdmc }}</span>
              <span class="table_r_last">{{ item.cgzb }}%</span>
            </div>
          </div>
        </div>
      </hgroup>
      <!-- 分红转送 -->
      <hgroup class="mainPage" v-if="shareBonusData && shareBonusData.fhpxList.length">
        <header>分红转送<a :href="shareBonusData.moreUrl">更多</a></header>
        <div class="m-block">
          <table class="m-table-two m-table-hk m-table-col3" border="0" width="100%">
            <tr>
              <th>除权除息日</th>
              <th>派息日</th>
              <th>分配方案</th>
            </tr>
            <tr v-for="(item, index) in shareBonusData.fhpxList.slice(0, 3)" :key="index">
              <td>{{ item.EXDATE_S }}</td>
              <td>{{ item.ISSUEDATE_S }}</td>
              <td>
                <strong>{{ item.FASM }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </hgroup>
      <!-- 、港股回购 -->
      <hgroup class="mainPage" v-if="repoData && repoData.gbhgList.length > 0">
        <header>
          港股回购<span>币种：{{ repoData.REPCUR }}</span
          ><a :href="repoData.hg_moreUrl">更多</a>
        </header>
        <div class="m-block">
          <table class="m-table-two m-table-hk m-table-col3" border="0" width="100%">
            <tr>
              <th>登记日</th>
              <th>回购金额</th>
              <th>占总股本比例</th>
            </tr>
            <tr v-for="(item, index) in repoData.gbhgList" :key="index">
              <td>{{ item.REPDATE_S }}</td>
              <td>{{ item.REPTOTPRICE }}</td>
              <td>{{ item.REPSHARENUM_P }}%</td>
            </tr>
          </table>
        </div>
      </hgroup>
      <!-- 拆股合股 -->
      <hgroup class="mainPage cghg" v-if="repoData && repoData.hbcxList.length > 0">
        <header>拆股合股<a :href="repoData.hbcx_moreUrl">更多</a></header>
        <div class="m-block">
          <table class="m-table-two m-table-hk m-table-col3" border="0" width="100%">
            <tr>
              <th>生效日</th>
              <th>类型</th>
              <th>拆合比例</th>
            </tr>
            <tbody v-for="(item, index) in repoData.hbcxList" :key="index">
              <tr>
                <td>{{ item.EFFECTDATE_S }}</td>
                <td>{{ item.CHLX }}</td>
                <td>{{ item.CHBL }}</td>
              </tr>
              <tr>
                <td colspan="3" class="td-colspan">
                  <span class="fl case-tit">方案说明：</span>
                  <div
                    :class="
                      unwindId.indexOf(index) !== -1 ? 'case-info' : 'case-info folder'
                    "
                  >
                    {{ item.FASM }}
                  </div>
                  <span
                    class="folder-more"
                    v-show="item.FASM.length > 48"
                    @click="unwind(index)"
                    >{{ unwindId.indexOf(index) !== -1 ? "收起" : "展开" }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </hgroup>
      <!-- 机构评级 -->
      <hgroup class="mainPage jggd" v-if="ratingData && ratingData.detailList.length > 0">
        <header>机构评级<a :href="ratingData.moreUrl">更多</a></header>
        <p class="idea-tips">
          最近6个月，{{ ratingData.number }}家机构评级以
          <strong class="font-red">{{ ratingData.type | recommendText }}</strong
          >为主
        </p>
        <div class="idea">
          <ul>
            <li :class="ratingData.type === 'MRNUM' ? 'ideaMr active' : 'ideaMr'">
              <span>买入</span>
            </li>
            <li :class="ratingData.type === 'ZCNUM' ? 'ideaZc active' : 'ideaZc'">
              <span>增持</span>
            </li>
            <li :class="ratingData.type === 'ZXNUM' ? 'ideaZx active' : 'ideaZx'">
              <span>中性</span>
            </li>
            <li :class="ratingData.type === 'JCNUM' ? 'ideaJc active' : 'ideaJc'">
              <span>减持</span>
            </li>
            <li :class="ratingData.type === 'MCNUM' ? 'ideaMc active' : 'ideaMc'">
              <span>卖出</span>
            </li>
          </ul>
          <span :class="ratingData.type | recommendColor">机构推荐</span>
        </div>
        <ul class="m-block">
          <li v-for="(item, index) in ratingData.detailList" :key="index">
            <span>{{ item.C7 }}</span>
            <span class="font-red">{{ item.description }}</span>
            <span>{{ item.C3 }}</span>
          </li>
        </ul>
      </hgroup>
      <!-- 行业地位 -->
      <hgroup class="mainPage hydw" v-if="industryData">
        <header>
          行业地位<span
            ><strong>{{ industryData.hydw.HSILEVEL2NAME }}</strong
            >-{{ industryData.hydw.BGQ }}</span
          ><a
            :href="
              industryData.cdn_url +
              industryData.root_path +
              industryData.stock_path +
              'HK_F10_Hydw_More.html?DZHSPECIAL=1'
            "
            >更多</a
          >
        </header>
        <h4 class="hy-tab tab4">
          <div class="hy-tab-wrap">
            <span
              v-for="(item, index) in statusList"
              :key="index"
              :class="index === statusId ? 'cur' : ''"
              @click="checkNav(index)"
              >{{ item }}</span
            >
          </div>
        </h4>
        <div class="hy-tab-content">
          <ol
            class="tab-content-item"
            v-for="(item, index) in industryData.hydw4list"
            :key="index"
            v-show="statusId === index"
          >
            <li v-for="(child, childId) in item" :key="childId" :rel-index="child.sort">
              <span>{{ child.stockNm }}</span
              ><span
                :class="'progress-bar progress-bar-' + child.datatype"
                data-percent="100%"
                ><strong :style="'width:' + child.percent + '%'"></strong></span
              ><span>{{ child.datanum }}{{ child.unit }}</span>
            </li>
          </ol>
        </div>
      </hgroup>
    </section>
    <Loading v-if="!affairDataShow && !modleDataShow && !makeDataShow"></Loading>
    <declare
      v-if="
        affairDataShow &&
        modleDataShow &&
        makeDataShow &&
        (eventData ||
          targetData ||
          makeData ||
          repoData ||
          industryData ||
          ratingData ||
          overviewData)
      "
    ></declare>
  </div>
</template>

<script>
import { getEventData, getYunToken } from "../api/index";
import mixins from "../mixins/index";
import Loading from "../components/loading";
import Declare from "../components/declare";
export default {
  name: "read",
  props: ["showTit", "token"],
  data() {
    return {
      statusList: ["每股收益", "每股净资产", "净利润", "营业收入"],
      statusId: 0,
      unwindId: [],
      code: "",
      eventData: null, // 事件提醒页面
      targetData: null, // 重要指标
      makeData: null, //主营构成
      repoData: null, //回购以及拆股合股
      industryData: null, //行业地位
      shareBonusData: null, //分红转送
      ratingData: null, // 机构评级
      gbjgData: null, // 股本结构
      dydgdData: null, // 第一大股东数据
      overviewData: null, // 公司概况数据
      affairDataShow: false,
      modleDataShow: false,
      makeDataShow: false,
      myChart: null,
      linkUrl: "",
      zyywShow: true, // 主要业务展开收起
      websocket: null,
      bkFs: null, //板块分时数据
    };
  },
  components: { Loading, Declare },
  mixins: [mixins],
  filters: {
    recommendColor: function (text) {
      switch (text) {
        case "MRNUM":
          return "ideaTips active01";
          break;
        case "ZCNUM":
          return "ideaTips active02";
          break;
        case "ZXNUM":
          return "ideaTips active03";
          break;
        case "JCNUM":
          return "ideaTips active04";
          break;
        case "MCNUM":
          return "ideaTips active05";
          break;
        default:
          break;
      }
    },
    recommendText: function (text) {
      switch (text) {
        case "MRNUM":
          return "买入";
          break;
        case "ZCNUM":
          return "增持";
          break;
        case "ZXNUM":
          return "中性";
          break;
        case "JCNUM":
          return "减持";
          break;
        case "MCNUM":
          return "卖出";
          break;
        default:
          break;
      }
    },
  },
  created() {},
  mounted() {
    this.code = this.getUrlQuery("code");
    this.linkUrl =
      window.config.url +
      "/wap/data/ipad/stock/" +
      this.code.substr(0, 2) +
      "/" +
      this.code.substr(-2) +
      "/" +
      this.code.substr(2) +
      "/f10/HK_F10_Zygc_Max.html?DZHSPECIAL=1";
    this.$nextTick(() => {
      this.getAffairData();
      this.getModleData();
      this.$nextTick(() => {
        this.getMakeData();
      });
    });
  },
  methods: {
    checkNav: function (id) {
      this.statusId = id;
    },
    unwind: function (id) {
      if (this.unwindId.indexOf(id) === -1) {
        this.unwindId.push(id);
      } else {
        var index = this.unwindId.indexOf(id);
        this.unwindId.splice(index, 1);
      }
    },
    // 获取事件提醒数据
    getAffairData: function () {
      let that = this;
      let targetKey = that.code + "-B1-3"; // 最新指标
      let eventKey = that.code + "-B1-1"; // 大事提醒数据
      let shareBonus = that.code + "-B5-1"; // 分红转送
      let zyldKey = "mapdata/gsgk/zyld/" + that.code; // 主要亮点
      let jbzlKey = "mapdata/gsgk/jbzl/" + that.code; // 上市信息
      let sshyKey = "mapdata/gsgk/sshy/" + that.code; // 所属行业
      let surveyKey = that.code + "-B7"; //获取主营业务

      let busiTypeArr = [
        eventKey,
        targetKey,
        shareBonus,
        zyldKey,
        jbzlKey,
        sshyKey,
        surveyKey,
      ];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.affairDataShow = true;
          if (res.resCode === "000000") {
            that.eventData =
              res.resData.hasOwnProperty(eventKey) &&
              res.resData[eventKey].sjtxList.length > 0
                ? res.resData[eventKey].sjtxList
                : null;
            that.targetData =
              res.resData.hasOwnProperty(targetKey) &&
              JSON.stringify(res.resData[targetKey].zyzb) !== "{}"
                ? res.resData[targetKey]
                : null;
            that.shareBonusData =
              res.resData.hasOwnProperty(shareBonus) && res.resData[shareBonus].fhpxList
                ? res.resData[shareBonus]
                : null;
            let zyldData =
              res.resData.hasOwnProperty(zyldKey) && res.resData[zyldKey]
                ? res.resData[zyldKey]
                : null;
            let jbzlData =
              res.resData.hasOwnProperty(jbzlKey) && res.resData[jbzlKey]
                ? res.resData[jbzlKey]
                : null;
            let sshyData =
              res.resData.hasOwnProperty(sshyKey) && res.resData[sshyKey]
                ? res.resData[sshyKey]
                : null;
            let surveyData =
              res.resData.hasOwnProperty(surveyKey) && res.resData[surveyKey]
                ? res.resData[surveyKey]
                : null;
            let objData = {
              bkdm: sshyData ? sshyData.data.bkdm : "",
              bkmc: surveyData.gszl ? surveyData.gszl.HSILEVEL2NAME : "",
              zyld: zyldData ? zyldData.zyld : "",
              zyyw: surveyData.gszl ? surveyData.gszl.MAJORBIZ : "",
              fxjg: jbzlData && jbzlData.data ? jbzlData.data.fxjg : "",
              ssrq: jbzlData && jbzlData.data ? jbzlData.data.ssrq : "",
            };
            that.overviewData = objData;
            if (objData.bkdm) {
              that.getTokenYun(objData.bkdm);
            }
          }
        })
        .catch(() => {
          that.affairDataShow = true;
        });
    },
    getModleData: function () {
      let that = this;
      let repo = that.code + "-B4-2"; // 回购以及拆股合股
      let industry = that.code + "-B12"; // 行业地位
      let ratingKey = that.code + "-B11-1"; // 机构评级
      let gbjgKey = "mapdata/gbgd/gbjg/" + that.code; //股本结构
      let busiTypeArr = [repo, industry, ratingKey, gbjgKey];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.modleDataShow = true;
          if (res.resCode === "000000") {
            that.repoData = res.resData.hasOwnProperty(repo) ? res.resData[repo] : null;
            that.industryData = res.resData.hasOwnProperty(industry)
              ? res.resData[industry]
              : null;
            that.ratingData = res.resData.hasOwnProperty(ratingKey)
              ? res.resData[ratingKey]
              : null;
            that.gbjgData = res.resData.hasOwnProperty(gbjgKey)
              ? that.checkGbjgData(res.resData[gbjgKey])
              : null;
            that.$nextTick(function () {
              if (that.gbjgData) {
                that.getDydgdData();
              }
            });
          }
        })
        .catch(() => {
          that.modleDataShow = true;
        });
    },
    // 主营业务
    getMakeData: function () {
      let that = this;
      var option = {
        color: ["#e25856", "#fd9946", "#fdbd43", "#ffc83a", "#ffe600"],
        tooltip: {
          formatter: "{b}",
          confine: true,
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      };
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: "mapdata/zygc/" + that.code + "/bd",
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.makeDataShow = true;
          if (res.resCode === "000000") {
            let data = res.resData.hasOwnProperty(objs.reqData.busiType)
              ? res.resData[objs.reqData.busiType]
              : null;
            let time = [];
            if (data) {
              for (let key in data) {
                time.push(key);
              }
              that.makeData = { time: time[0], arr: data[time[0]].slice(0, 3) };
              let arr = [];
              that.$nextTick(() => {
                if (data[time[0]] !== null && data[time[0]].length > 0) {
                  try {
                    let total = data[time[0]][0].biztotinco - 0;
                    let values = 0;
                    for (let i = 0; i < that.makeData.arr.length; i++) {
                      values += that.makeData.arr[i]["panVale"] - 0;
                      let obj = {};
                      obj.value = (
                        (that.makeData.arr[i]["panVale"] / total) *
                        100
                      ).toFixed(2);
                      obj.name = that.makeData.arr[i]["pbacname"];
                      arr.push(obj);
                    }
                    arr.push({
                      value: (((total - values) / total) * 100).toFixed(2),
                      name: "其他",
                    });
                    setTimeout(() => {
                      that.myChart = that.$echarts.init(
                        document.getElementById("zygcPie")
                      );
                      option.series[0].data = arr;
                      that.$nextTick(() => {
                        that.myChart.setOption(option);
                      });
                    }, 800);
                  } catch (e) {
                    console.log(e);
                  }
                } else {
                  that.makeData = null;
                }
              });
            }
          }
        })
        .catch(() => {
          that.makeDataShow = true;
        });
    },
    // 请求第一大股东
    getDydgdData: function () {
      let that = this;
      let dydgdKey = "mapdata/gbgd/dydgd/" + that.code; //第一大股东
      let busiTypeArr = [dydgdKey];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token).then((res) => {
        if (res.resCode === "000000") {
          this.dydgdData =
            res.resData.hasOwnProperty(busiTypeArr) &&
            res.resData[busiTypeArr].data.length
              ? res.resData[busiTypeArr].data
              : null;
        }
      });
    },

    // 获取云平台token
    getTokenYun: function (code) {
      let that = this;
      let obj = {
        appid: window.config.yunId,
        secret_key: window.config.yunkey,
      };
      getYunToken(obj).then((res) => {
        if (res.Err === 0 && res.Data.RepDataToken) {
          that.getStocksZf(res.Data.RepDataToken[0].token, code);
        }
      });
    },

    // 获取板块行情数据
    getStocksZf: function (token, code) {
      let that = this;
      code = "K$" + code;
      if (!this.websocket) {
        this.websocket = new WebSocket(`${window.config.wsurl}/ws?token=${token}`);
        this.websocket.onopen = () => {
          this.websocketSend(code);
        };
      } else {
        this.websocket.send(`/cancel?qid=1`);
        this.websocketSend(code);
      }
      this.websocket.onmessage = (evt) => {
        let fr = new FileReader();
        fr.readAsText(evt.data);
        fr.onload = () => {
          let result = JSON.parse(fr.result);
          let dynaList = result.Data.RepDataStkData;
          if (dynaList) {
            that.bkFs = dynaList[0].ZhangFu;
          }
        };
      };
      this.websocket.onclose = () => {
        this.websocket.close();
        this.websocket = null;
        this.getTokenYun();
      };
    },

    websocketSend(code) {
      this.websocket.send(
        `/quote/stkdata?obj=${code}&field=ZhongWenJianCheng,ZhangFu&qid=1&sub=1`
      );
    },

    // 大事提醒点击打开
    showsjtx: function (id) {
      if (this.eventData[id].show) {
        this.$set(this.eventData[id], "show", false);
      } else {
        this.$set(this.eventData[id], "show", true);
      }
    },
    // 点击跳转大事提醒tab
    goLink: function () {
      this.$parent.showTit = "大事提醒";
    },
    // 跳转板块分时
    goFs: function (code) {
      location.href = `dzh_browser_url&goto=0&type=2970&code=K$${code.replace(
        "B$",
        "BI"
      )}&kind=0`;
    },
  },
};
</script>
<style lang="less" scoped>
.canvas-circle {
  overflow: inherit !important;
}
.small_lab {
  font-size: 0.2rem !important;
}
</style>
